import image from 'img/aside-promo-modal/autoUploadPromo.png';
import imageDark from 'img/aside-promo-modal/autoUploadPromoDark.png';
import React from 'react';
import { IS_AUTO_TEST_HIDE, platform } from 'reactApp/appHelpers/configHelpers';
import { autoUploadPromo, helpAutoUploadHref } from 'reactApp/appHelpers/featuresHelpers/features/autoUploadPromo';
import { PaymentUTM } from 'reactApp/constants/paymentUTM';
import { storeHelper } from 'reactApp/modules/promo/promo.helpers';
import { addPromoToShowQueue, promoShown, removePromo } from 'reactApp/modules/promo/promo.module';
import { PromoSelectors } from 'reactApp/modules/promo/promo.selectors';
import { EPromoType } from 'reactApp/modules/promo/promo.types';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { UserStorageActions } from 'reactApp/modules/user/userStorage';
import { getQuotaPromoUrl } from 'reactApp/sections/QuotaLanding/QuotaLanding.data';
import { store as reduxStore } from 'reactApp/store';
import { openAsidePromoModal } from 'reactApp/ui/AsidePromoModal/AsidePromoModal.helpers';
import { sendDwh, sendXray } from 'reactApp/utils/ga';
import { isDarkThemeModeEnabled } from 'reactApp/utils/theme';
import { put } from 'redux-saga/effects';
import { select } from 'typed-redux-saga';

const PROMO_ID = 'autoupload-promo';
const PROMO_SHOW_COUNT = `${PROMO_ID}-count`;
const PERIOD_IN_DAYS = 1;
const MAX_SHOWN_COUNT = 3;

const sendRadar = (action: 'show' | 'click' | 'close') => {
    sendXray(['autoupload_sidebar', platform, action]);
    sendDwh({
        eventCategory: 'balloon',
        action,
        dwhData: { name: 'mnz_unlimited_upload', platform },
    });
};

export function* initAutoUploadAsidePromo() {
    const storage = yield* select(getCurrentStorage);
    const { isHome } = getStorage(storage);
    const isCorpUser = yield* select(UserSelectors.isCorpUser);
    const isBizUser = yield* select(UserSelectors.isBizUser);
    const isPaidUser = yield* select(UserSelectors.isPaidUser);
    const shownCount = yield put(UserStorageActions.get(PROMO_SHOW_COUNT)) || 0;

    // Форс-включение промки для отдельных автотестов.
    const force = yield put(UserStorageActions.get(`force_${PROMO_ID}`)) || false;

    if (shownCount >= MAX_SHOWN_COUNT) {
        return;
    }

    const periodPassed = storeHelper.getValue(PROMO_ID) && storeHelper.isPassed(PROMO_ID, { daysCount: PERIOD_IN_DAYS });

    if (periodPassed) {
        storeHelper.clearStore(PROMO_ID);
    }

    if (
        !autoUploadPromo ||
        !isHome ||
        (IS_AUTO_TEST_HIDE && !force) ||
        isBizUser ||
        isCorpUser ||
        storeHelper.getValue(PROMO_ID) ||
        isPaidUser
    ) {
        return;
    }

    yield put(
        addPromoToShowQueue({
            type: EPromoType.autoUpload,
            promoId: PROMO_ID,
            onClick: () => {
                reduxStore.dispatch(removePromo(EPromoType.autoUpload));
                reduxStore.dispatch(UserStorageActions.set(PROMO_SHOW_COUNT, 4));
                sendRadar('click');
                open(
                    getQuotaPromoUrl({
                        query: `min_tariff=256&${PaymentUTM.unlimitedUploadBalloon}`,
                    }),
                    '_self'
                );
            },
            onShow: () => {
                reduxStore.dispatch(promoShown(EPromoType.autoUpload));
                reduxStore.dispatch(UserStorageActions.set(PROMO_SHOW_COUNT, shownCount + 1));
                sendRadar('show');
            },
            onClose: () => {
                reduxStore.dispatch(removePromo(EPromoType.autoUpload));
                reduxStore.dispatch(UserStorageActions.set(PROMO_SHOW_COUNT, 4));
                sendRadar('close');
            },
        })
    );
}

export function* showAutoUploadAsidePromo() {
    const promo = yield* select(PromoSelectors.getPromo(EPromoType.autoUpload));

    if (promo) {
        const { onShow, onClick, onClose } = promo;

        const isDarkTheme = isDarkThemeModeEnabled();

        const content = (
            <>
                Подключите любой тариф — галерея
                <br />
                из телефона загрузится в Облако,
                <br />а место не займёт.{' '}
                {!!helpAutoUploadHref && (
                    <a href={helpAutoUploadHref} target="_blank" rel="noopener noreferrer">
                        Как это работает
                    </a>
                )}
            </>
        );

        yield openAsidePromoModal({
            title: 'Автозагрузка может быть безлимитной',
            text: content,
            buttonText: 'Выбрать тариф',
            imageUrl: isDarkTheme ? imageDark : image,
            qaId: 'autoupload-promo',
            textCompact: true,
            closeOnNavigation: true,
            showAboveViewer: true,
            href: getQuotaPromoUrl({
                query: `min_tariff=256&${PaymentUTM.unlimitedUploadBalloon}`,
            }),
            onShow,
            onClick,
            onClose,
        });
    }
}
